import TkInfoManual from "../../components/atoms/TkInfoManual";
import { fakeTableList, schema, stepperData } from "./parts";
import { Box } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TkStepper from "../../components/atoms/TkStepper";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import { httpIAPI_CON008, httpIAPI_CON015 } from "./api/request";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { formClassCorp, FormKbn, Status } from "../../assets/data/Constants";
import _ from "lodash";

/**
 * SCRC050016 契約解除（加入者全員の同意）　入力内容確認
 * @return SCRC050016
 */
const SCRC050016 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);
  const context = businessState?.job_04;
  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const [stateTableList, setStateTableList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState<any>(1);
  const [showButton, setShowButton] = useState(true);
  const applyId = location.state?.applyId ?? businessState?.job_04?.applyId;
  const contractorNo = isKiko
    ? businessState.common?.contractorNo
    : state.authInfo?.contractorNo;

  //更新APIを呼ぶ際に必要になる項目
  const updataDataRef = useRef({
    applyId,
    contractorNo,
    cancelDate: context?.cancelDate ?? location?.state.cancelDate,
    cancelDayMaStaffNum: location.state?.maStaffNum,
    cancelReason: context?.cancelReason ?? location.state.cancelReason,
    formList: location?.state?.formList?.map(
      ({ facilityNo, fileName, fileBase64 }: any, index: number) => ({
        serialNo: index + 1,
        facilityNo,
        formKbn: FormKbn["法人書類"],
        formClass: formClassCorp["契約解除同意書"],
        fileName,
        fileBase64,
      })
    ),
    facilityList: location.state?.facilityList,
    screenId: "SCRC050016",
  });

  const updataData = updataDataRef.current;

  useEffect(() => {
    const fetchData = async () => {
      let resArr = stateFakeTableList.current;
      let resData: any = {};

      if (location?.state?.applyId) {
        // 退職手当共済契約解除参照 を呼び出す
        try {
          const res = await httpIAPI_CON008({
            applyId,
            contractorNo,
          });

          if (res.resultCd === "I0000") {
            updataDataRef.current = {
              ...updataDataRef.current,
              applyId,
              contractorNo,
              cancelDate: res.cancelDate,
              cancelDayMaStaffNum: res.maStaffNum,
              cancelReason: res.cancelReason,
              formList: res.formList?.map(
                ({ facilityNo, fileName, fileBase64 }: any, index: number) => ({
                  serialNo: index + 1,
                  facilityNo,
                  formKbn: FormKbn["法人書類"],
                  formClass: formClassCorp["契約解除同意書"],
                  fileName,
                  fileBase64,
                })
              ),
              facilityList: res.facilityList,
              screenId: "SCRC050016",
            };

            if (
              res.latestApplyStatus === Status["届出待ち"] ||
              res.latestApplyStatus === Status["差戻し一時保存"]
            ) {
              setStep(1);
              setShowButton(true);
            } else {
              setStep(2);
              setShowButton(false);
            }

            resData = res;
          } else {
            setState({
              ...state,
              errorMsgId: res.resultCd,
            });

            resData = {};
          }
        } catch (error) {
          navigate("/error");
          return;
        }
      }

      let cacelDate = resArr.find((item) => item.keyword === "cacelDate")!;
      cacelDate.text =
        resData?.cancelDate ??
        context?.cancelDate ??
        location.state?.cancelDate;

      let maStaffNum = resArr.find((item) => item.keyword === "maStaffNum")!;
      maStaffNum.text =
        (resData?.maStaffNum ?? location?.state.maStaffNum) + "人";

      let formList = resArr.find((item) => item.keyword === "formList")!;
      const formListAllDatas = resData.formList ?? location?.state?.formList;

      const formListData = formListAllDatas?.filter(
        (item: any) => item.formClass === "7"
      );

      formList.node = (
        <Box className="SCRC050016Link">
          {formListData?.map(
            (item: any) =>
              item.fileName &&
              item.fileBase64 && (
                <>
                  <TkDownloadLink
                    key={item.fileName}
                    dataname={item.fileName}
                    base64filedata={item.fileBase64}
                    downloadBase64={true}
                  ></TkDownloadLink>
                  <br />
                </>
              )
          )}
        </Box>
      );

      let cancelReason = resArr.find(
        (item) => item.keyword === "cancelReason"
      )!;
      cancelReason.text =
        resData?.cancelReason ??
        context?.cancelReason ??
        location.state?.cancelReason;

      setStateTableList([...resArr]);
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOk = async (date?: any) => {
    const upData = Object.assign({}, updataData);
    try {
      const res = await httpIAPI_CON015({
        ...upData,
        receptionDate: date,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRC070008");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        setOpen(false);
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleSubmit = () => {
    setOpen(true);
  };

  return (
    <Box data-testid="SCRC050016PageForTest">
      <TkStepper
        steps={stepperData}
        savaStep={context?.tempSaveStep}
        activeStep={step}
      />
      <TkInfoManual rule="\n">{labelids.labelid.LBLC050016_01}</TkInfoManual>
      {isKiko && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={`${businessState.common?.contractorNo ?? ""}:${
            businessState.common?.contractorName ?? ""
          }`}
        />
      )}

      <TkFakeTable
        list={stateTableList}
        ruleSchema={schema}
        showButton={showButton}
        submitButtonText={isKiko ? "申請" : "機構へ提出する"}
        buttonGroup={<TkBackButton />}
        onCheckAndSubmit={handleSubmit}
      />

      {isKiko ? (
        <TkDateDialog
          open={open}
          onOky={handleOk}
          onCancel={() => setOpen(false)}
          minDate={new Date("1900/01/01")}
          maxDate={new Date()}
          title="確認（申請）"
          contextText="申請を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
      ) : (
        <TkMessageDialog
          open={open}
          onOky={handleOk}
          onCancel={() => setOpen(false)}
          title="確認（機構へ提出する）"
          contextText="機構へ提出を行いますが、問題ないでしょうか。"
          okText="はい"
          cancelText="いいえ"
        />
      )}
    </Box>
  );
};

export default SCRC050016;
